import React, { useState } from "react"
import { Flex, Box, useOutsideClick } from "@chakra-ui/react"
import { colors } from "@app/theme/colors"
import Icon from "@components/Icon/Icon"

const SortByDropdown: React.FC = props => {
  const ref = React.useRef()
  const [isOpen, setIsOpen] = useState(false)

  useOutsideClick({
    ref: ref,
    handler: () => setIsOpen(false),
  })

  return (
    <Flex position="relative" mr={1} ref={ref}>
      <Flex
        fontSize="15px"
        fontWeight={"medium"}
        alignItems={"center"}
        borderRadius="5px"
        px="16px"
        py={"8px"}
        onClick={() => setIsOpen(!isOpen)}
        cursor="pointer"
        border={`1px solid ${colors.brand.border}`}
        bg={isOpen ? colors.brand.beige.light : "white"}
      >
        Sort By: <span style={{ paddingLeft: "6px", fontWeight: "bold" }}>{props.sortOption && props.sortOption.name}</span>
        <Box transform={isOpen ? "rotateX(180deg)" : "rotateX(0deg)"}>
          <Icon ml="10px" name="chevronDown" size="14px" color="black"></Icon>
        </Box>
      </Flex>
      {isOpen && (
        <Flex
          zIndex={6}
          bg={"white"}
          border={`1px solid ${colors.brand.border}`}
          borderRadius="5px"
          py={1}
          flexDirection={"column"}
          position="absolute"
          top={"100%"}
          left={0}
        >
          {props.sortOptions.map((option: any, idx: number) => (
            <Flex
              onClick={() => {
                // something
                props.setSortOption(option.handle)
              }}
              textTransform={"capitalize"}
              px={2}
              py={1}
              cursor="pointer"
              key={idx}
              fontWeight="medium"
              whiteSpace={"nowrap"}
              fontSize={"12px"}
              _hover={{
                bg: colors.brand.beige.light,
              }}
            >
              {option.name}
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  )
}

export default SortByDropdown
